import { connect } from 'react-redux';

import addAbilityToOpenModal from '../../../utilities/modalHOC';
import { setCouponDetail, setDeleteCoupon } from '../../Coupons/actions';
import {
  createSubcodes,
  deleteDisableCoupon,
  editNewCoupon,
  listPlansSubscriptions,
  loadNewCouponsAction,
  loadSubcodes,
} from '../../Coupons/actionsSagas';
import {
  getCouponDetail,
  getDeleteCoupon,
  getLoadCoupons,
  getNewCoupons,
  setPlansSubscriptions,
} from '../../Coupons/selectors';
import { getPermissions } from '../../Login/selectors';
import couponDetail from './couponDetail';

const mapStateToProps = (state, ownProps) => ({
  newCoupons: getNewCoupons(state),
  couponDetail: getCouponDetail(state),
  plansSubscriptions: setPlansSubscriptions(state),
  loadCoupons: getLoadCoupons(state),
  deleteCoupon: getDeleteCoupon(state),
  permissions: getPermissions(state),
});

const mapDispatchToProps = (dispatch) => ({
  setCouponDetail: (value) => dispatch(setCouponDetail(value)),
  deleteDisableCoupon: (coupon, value) =>
    dispatch(deleteDisableCoupon(coupon, value)),
  editCoupon: (updatedCoupon, couponName) =>
    dispatch(editNewCoupon(updatedCoupon, couponName)),
  loadNewCoupons: () => dispatch(loadNewCouponsAction()),
  listPlansSubscriptions: () => dispatch(listPlansSubscriptions()),
  setDeleteCoupon: (value) => dispatch(setDeleteCoupon(value)),
  createSubcodes: (couponName) => dispatch(createSubcodes(couponName)),
  loadSubcodes: (couponName) => dispatch(loadSubcodes(couponName)),
});

const couponDetailContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(couponDetail);

export default addAbilityToOpenModal(couponDetailContainer);
